import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_containerProps"];
import React from 'react';
import View from '@bubble-ui/primitive-view';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import { useDesignContext } from '@klarna/designtokens';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var KlarnaK_small = _ref => {
  var {
    color
  } = _ref;
  return /*#__PURE__*/React.createElement(Surface, {
    width: "19",
    height: "16"
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M16.315 11.895a1.925 1.925 0 110 3.85 1.925 1.925 0 010-3.85zM12.645.255c0 3.316-1.293 6.4-3.595 8.694l4.857 6.624h-4.34l-5.28-7.199 1.363-1.02A8.796 8.796 0 009.205.255zm-8.778 0v15.318H.343V.255h3.524z",
    fill: color,
    fillRule: "evenodd"
  }));
};
var KlarnaK_medium = _ref2 => {
  var {
    color
  } = _ref2;
  return /*#__PURE__*/React.createElement(Surface, {
    width: "25",
    height: "22"
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M21.08725,15.1936 C22.50475,15.1936 23.65375,16.3426 23.65375,17.7601 C23.65375,19.1776 22.50475,20.3266 21.08725,20.3266 C19.66975,20.3266 18.52075,19.1776 18.52075,17.7601 C18.52075,16.3426 19.66975,15.1936 21.08725,15.1936 Z M16.193,-0.3266 C16.193,4.0949 14.4695,8.2079 11.3995,11.2654 L11.3995,11.2654 L17.8765,20.0974 L12.089,20.0974 L5.0495,10.4989 L6.8665,9.1384 C9.879,6.8814 11.607,3.4319 11.607,-0.3266 L11.607,-0.3266 Z M4.4895,-0.3265 L4.4895,20.0975 L-0.209,20.0975 L-0.209,-0.3265 L4.4895,-0.3265 Z",
    fill: color,
    fillRule: "evenodd"
  }));
};
var KlarnaK_regular = _ref3 => {
  var {
    color
  } = _ref3;
  return /*#__PURE__*/React.createElement(Surface, {
    width: "31",
    height: "26"
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M26.86 19.492a3.208 3.208 0 110 6.416 3.208 3.208 0 010-6.416zM20.74.092c0 5.527-2.154 10.668-5.992 14.49l8.097 11.04H15.61l-8.8-11.998 2.272-1.701C12.85 9.102 15.01 4.79 15.01.092zm-14.63 0v25.53H.24V.092h5.873z",
    fill: color,
    fillRule: "evenodd"
  }));
};
var KlarnaK_large = _ref4 => {
  var {
    color
  } = _ref4;
  return /*#__PURE__*/React.createElement(Surface, {
    width: "42",
    height: "38"
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M37.403 28.089a4.491 4.491 0 110 8.982 4.491 4.491 0 010-8.982zM28.838.929c0 7.737-3.016 14.935-8.389 20.285L31.784 36.67H21.656L9.336 19.873l3.18-2.38c5.272-3.95 8.296-9.987 8.296-16.565zm-20.481 0V36.67H.134V.929h8.223z",
    fill: color,
    fillRule: "evenodd"
  }));
};
var KlarnaAvatar = _ref5 => {
  var {
      accessibilityLabel,
      id,
      size,
      testID,
      UNSAFE_containerProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref5,
    props = _objectWithoutProperties(_ref5, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'KlarnaAvatar',
    props,
    useInstead: 'UNSAFE_containerProps',
    removalDate: 'v7.0.0'
  });
  var designContext = useDesignContext(defaultDesignTokens);
  var ids = getIds(id);
  var {
    logoStyle,
    logoLetterStyle
  } = getDefaultStyleSheet({
    designContext,
    size
  });
  var KlarnaK = size === 'small' ? KlarnaK_small : size === 'medium' ? KlarnaK_medium : size === 'large' ? KlarnaK_large : KlarnaK_regular;
  return /*#__PURE__*/React.createElement(View, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    testID: testID
  }, UNSAFE_containerProps, {
    accessibilityLabel: accessibilityLabel,
    style: logoStyle
  }, props), /*#__PURE__*/React.createElement(View, {
    style: logoLetterStyle
  }, /*#__PURE__*/React.createElement(KlarnaK, {
    color: logoLetterStyle.color
  })));
};
KlarnaAvatar.displayName = 'KlarnaAvatar';
export default withProvisionalOverrideFromContext(KlarnaAvatar);
//# sourceMappingURL=index.js.map